<template>
  <section class="commentInputer">
    <input
      :value="value"
      @input="$emit('input', $event.target.value)"
      :placeholder="placeholder"/>
    <button @click="send">发送</button>
  </section>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: ''
    },

    placeholder: {
      type: String,
      default: '我想说...'
    },

    send: {
      type: Function,
      default: () => alert('Send')
    }
  }
}
</script>

<style lang="scss" scoped>
@charset "UTF-8";
@import "../../style/main";

$global-width: 750;

.commentInputer {
  position: relative;
  height: rem(90);
  width: 100%;
  padding: rem(20) rem(30);
  box-sizing: border-box;
  background-color: #fff;
  border-top: rem(1) solid #E4E4E4;

  input {
    height: rem(50);
    width: rem(570);
    margin-right: rem(20);
    color: #000;
    font-size: rem(26);
    line-height: rem(50);
    text-indent: rem(20);
    border-radius: rem(4);
    background-color: #F3F4F6;

    &::-webkit-input-placeholder {
      color: #999;
    }
  }

  button {
    height: rem(50);
    width: rem(100);
    color: #fff;
    line-height: rem(50);
    border: none;
    outline: none;
    background-color: #F48F00;
  }

}

</style>
